export default "__VITE_ASSET__cRhx_$aT__"